var comp = 'tooltip-on-ellipsis';
export var dataHooks = {
  content: "".concat(comp, "-content"),
  contentContainer: "".concat(comp, "-content--container")
};
export var RELEVANT_STYLE_PROPERTIES = ['border', 'borderRightWidth', 'borderLeftWidth', 'borderRightStyle', 'borderLeftStyle', 'boxSizing', 'font', 'fontSize', 'fontFamily', 'fontStyle', 'fontWeight', 'fontVariant', 'fontKerning', 'fontFeatureSettings', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontSizeAdjust', 'fontStretch', 'letterSpacing', 'padding', 'paddingRight', 'paddingLeft', 'textIndent', 'textTransform', 'transform', 'wordSpacing'];
export var MEASURE_STYLE = {
  visibility: 'hidden',
  height: 0,
  position: 'absolute',
  top: 0,
  whiteSpace: 'nowrap'
};